import { FC } from 'react';
import { useSelector } from 'react-redux';


import './styles.scss';
import { GlobalState } from '@types';

const OperatorPrinting: FC = () => {
  const { isOperatorPrinting } = useSelector((state: GlobalState) => ({
    isOperatorPrinting: state.behavior.isOperatorPrinting
  }));

  if (!isOperatorPrinting) return  <div className="rcw-operator-printing"/>;

  return (
    <div className="rcw-operator-printing">
      <span>Оператор печатает...</span>
    </div>
  );
};

export default OperatorPrinting; 
